import { createContext, useContext } from 'react'
export type headbandType = string
type context = {
   headband: headbandType
   setHeadband: (headband: headbandType) => void
}

const HeadbandContext = createContext<context>({
   headband: '',
   setHeadband: (headband) => headband,
})
export const useHeadbandContext = () => useContext(HeadbandContext)
export default HeadbandContext
